import Vue from 'vue';

Vue.directive('uppercase', {
    bind: function(el, binding, vnode, oldVnode) {
        binding.onKeyUp = (e) => {
            e.target.value = e.target.value.toUpperCase();
            if (vnode.componentInstance) {
                return vnode.componentInstance.$emit('input', { detail: e.target.value.toUpperCase() });
            }
            return vnode.elm.dispatchEvent(new CustomEvent('input', { detail: e.target.value.toUpperCase() }));
        };
        el.addEventListener('keyup', binding.onKeyUp);
        el.classList.add('text-uppercase');
    },
    unbind: function (el, binding, vnode) {
        el.removeEventListener('keyup', binding.onKeyUp);
        el.classList.remove('text-uppercase');
    }
});
